import { DP_IDS_HOLDING, DP_TRANSACTION_HISTORY_HOLDING, DP_TRANSACTION_HISTORY_LOADER, DP_TRANSACTION_MAIN_LOADER, EMPTY_DP_TRANSACTION_VALIDATION, HIDE_EMPTY_DP_TRANSACTION_VALIDATION, HOLDING_EMPTY_VALIDATION, HOLDING_ERROR, HOLDING_HIDE_EMPTY_VALIDATION, HOLDING_HIDE_ERROR, HOLDING_LOADER, HOLDING_REPORT, PROD_ASSET_FILTER_VAL_HOLDING, SAVE_SMTF, SELECTED_ROW_INDEX, } from "../../interfaces/Reports/iHoldingReport";
import { UNDERSTANDING_ERROR, UNDERSTANDING_HIDE_ERROR, UNDERSTANDING_SECTION, } from "../../interfaces/Reports/iUnderstandingSection";
import store from "../../store";
class HoldingReportsActions {
    constructor() {
        this.dispatch = store.dispatch;
    }
    setHoldingLoader(loader) {
        this.dispatch({
            type: HOLDING_LOADER,
            payload: { loader },
        });
    }
    setEmptyDPValidation(emptyValidation) {
        this.dispatch({
            type: EMPTY_DP_TRANSACTION_VALIDATION,
            payload: { emptyDpTransaction: emptyValidation.emptyDpTransaction },
        });
    }
    hideDPEmptyValidation() {
        this.dispatch({
            type: HIDE_EMPTY_DP_TRANSACTION_VALIDATION,
        });
    }
    setEmptyValidation(emptyValidation) {
        this.dispatch({
            type: HOLDING_EMPTY_VALIDATION,
            payload: emptyValidation,
        });
    }
    hideEmptyValidation() {
        this.dispatch({
            type: HOLDING_HIDE_EMPTY_VALIDATION,
        });
    }
    getHoldingReportData(HoldingReportEntityList) {
        this.dispatch({
            type: HOLDING_REPORT,
            payload: {
                data: HoldingReportEntityList,
            },
        });
    }
    setSelectedRowIndex(selectedRowIndex) {
        this.dispatch({
            type: SELECTED_ROW_INDEX,
            payload: {
                selectedRowIndex,
            },
        });
    }
    getDpIds(dpTransactionEntity) {
        this.dispatch({
            type: DP_IDS_HOLDING,
            payload: {
                dpTransactionEntity,
            },
        });
    }
    setDpTransactionHistory(dpTransactionEntity) {
        this.dispatch({
            type: DP_TRANSACTION_HISTORY_HOLDING,
            payload: {
                dpTransactionEntity,
            },
        });
    }
    getUnderstandingSectionData(understand) {
        this.dispatch({
            type: UNDERSTANDING_SECTION,
            payload: {
                data: understand,
            },
        });
    }
    toggleDpTransactionMainLoader(shimer) {
        this.dispatch({
            type: DP_TRANSACTION_MAIN_LOADER,
            payload: {
                dpTransactionMainLoader: shimer,
            },
        });
    }
    toggleDpTransactionLoader(shimer) {
        this.dispatch({
            type: DP_TRANSACTION_HISTORY_LOADER,
            payload: {
                dpTransactionLoader: shimer,
            },
        });
    }
    setError(payload, errorType) {
        this.dispatch({
            type: HOLDING_ERROR,
            payload: {
                errorData: payload,
            },
            errorType,
        });
    }
    hideError(errorType) {
        this.dispatch({
            type: HOLDING_HIDE_ERROR,
            errorType,
        });
    }
    setErrorUnderStandings(payloadError) {
        this.dispatch({
            type: UNDERSTANDING_ERROR,
            payload: {
                errorData: payloadError,
            },
        });
    }
    hideUnderstandingError() {
        this.dispatch({
            type: UNDERSTANDING_HIDE_ERROR,
        });
    }
    saveProdAssetDropDown(prodDropDown, activeAssetTab) {
        this.dispatch({
            type: PROD_ASSET_FILTER_VAL_HOLDING,
            payload: { prodDropDown: prodDropDown, activeAssetTab },
        });
    }
    saveSMTF(smtf) {
        this.dispatch({
            type: SAVE_SMTF,
            payload: { smtf: smtf },
        });
    }
}
export default HoldingReportsActions;
